import React from "react";
import { SizePill, SizePills } from "web/react/components/size-pills/size-pills";
import { StandardFilterProps } from "web/types/feed-filters";
import { InputFilterOption, SizesFilterSection } from "web/types/universal-filters";
import styles from "./feed-filter-sizes.module.css";

export function FeedFilterSizes(props: FeedFilterSizesProps): JSX.Element {
    const pills = (props.item.option_groups[0].options as InputFilterOption[]).map(
        (size): SizePill => ({
            id: size.id,
            url: size.url,
            label: size.label,
            checked: props.pendingFilterInfo.getChecked(size),
            onClick: () => props.onClick(size),
        })
    );

    return <SizePills pills={pills} className={styles.wrapper} />;
}

interface FeedFilterSizesProps extends StandardFilterProps {
    item: SizesFilterSection;
}
